import React, { useEffect } from "react";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ServiceSection from "./components/ServiceSection";
import ClientsSection from "./components/ClientsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import "./App.css";

function App() {
  useEffect(() => {
    const hide = () => {
      const b = document.getElementById("emergent-badge");
      if (b) b.style.cssText = "display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;position:fixed!important;bottom:-999px!important;";
    };
    hide();
    const t1 = setTimeout(hide, 500);
    const t2 = setTimeout(hide, 2000);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  return (
    <LanguageProvider>
      <div style={{ background: "#fafafa", color: "#333333", overflowX: "hidden" }}>
        <Header />
        <main style={{ paddingTop: "100px" }}>
          <HeroSection />
          <AboutSection />
          <ServiceSection type="strategy" />
          <ServiceSection type="contentCreation" />
          <ServiceSection type="campaigns" />
          <ServiceSection type="webAutomation" />
          <ClientsSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
